import React from "react";
import "../styles/InterviewMistakes.css";

const InterviewMistakes = () => {
  return (
    <div className="interview-mistakes-page">
      <h1>❌ Common Interview Mistakes to Avoid</h1>
      <p>Don't let simple mistakes cost you your dream job. Learn what to avoid!</p>

      <section className="mistakes-list">
        <h2>🚩 Top Interview Mistakes</h2>
        <ul>
          <li><strong>1. Not Researching the Company:</strong> Always understand the company’s mission, products, and latest updates.</li>
          <li><strong>2. Poor Body Language:</strong> Maintain eye contact and sit confidently.</li>
          <li><strong>3. Talking Too Much or Too Little:</strong> Be concise but provide enough detail.</li>
          <li><strong>4. Not Practicing Common Questions:</strong> Prepare for behavioral and technical questions.</li>
          <li><strong>5. Forgetting to Ask Questions:</strong> Show interest by asking about the company culture and role expectations.</li>
        </ul>
      </section>

      <section className="interview-prep">
        <h2>💼 Ace Your Next Interview!</h2>
        <p>Practice with real interview questions and mock interview sessions.</p>
        <a href="/mock-interviews" className="btn primary-btn">Try Mock Interviews</a>
      </section>
    </div>
  );
};

export default InterviewMistakes;
